import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { SEO } from "@/components/SEO/SEO";

import { Banner } from "./components/Banner";
import { Tiendas } from "./components/Tiendas";
import { ProductosDestacados } from "./components/ProductosDestacados";

import { useMachine } from "@/_zustand/machine";
import { homeStore } from "@/_zustand/home";
import { LoMasComprado } from "./components/LoMasComprado";

export const Home = () => {
  const { clearMachine } = useMachine();
  const { clearAll } = homeStore();
  const params = useParams();

  useEffect(() => {
    if (!params.idEmpresa) {
      clearMachine();
      clearAll();
    }
  }, [params.idEmpresa, clearMachine, clearAll]);

  return (
    <>
      <SEO
        title="Inicio"
        description="Descubre las mejores máquinas vending cerca de ti. Compra online con delivery o retiro."
        url="/"
      />
      <Banner />
      <Tiendas />
      <ProductosDestacados />
      <LoMasComprado />
      {/* <Stores /> */}
    </>
  );
};
